module.exports = __webpack_public_path__ + "media/investor_dashboard/bulb-e8ea2e1e.png";